/**
 * Return range mapped number
 *
 * @param  {number} current
 * @param  {number} in_min
 * @param  {number} in_max
 * @param  {number} out_min
 * @param  {number} out_max
 * @returns {number} mapped value
 */
function rangeMapper(current:number, in_min:number, in_max:number, out_min:number, out_max:number): number { // eslint-disable-line
  return (current - in_min) * (out_max - out_min) / (in_max - in_min) + out_min; // eslint-disable-line
}
/**
 * Clamp a number between a min and max
 *
 * @param  {number} number
 * @param  {number} min
 * @param  {number} max
 * @returns {number} clamped value
 */
function clampNumber(number:number, min:number, max:number): number {
  if (number >= max) {
    return max;
  }

  if (number <= min) {
    return min;
  }

  return number;
}

const rem = (int:number) => int * 8;

export {
  rangeMapper,
  clampNumber,
  rem,
};
